// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScrollText_wrapper__6PY7J","parallax":"ScrollText_parallax__2kY2d"};